export default "__VITE_ASSET__CkSoLK8B__"